export default {"src":"/_next/static/media/linkedin.848c3017.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};